import { forwardRef } from 'react'

import {
  DateInput,
  NumberInput,
  SearchInput,
  InputComponent,
  InputBaseStyles
} from './inputStyles'
import InputTypes from './inputTypes'

interface CommonInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant: 'default' | 'date' | 'number' | 'search' | 'inputComponent'
  invalid?: boolean
  active?: boolean
  uppercase?: boolean
  withRef?: boolean
}

const CommonInput = forwardRef<HTMLInputElement, CommonInputProps>(
  (props, ref) => {
    const { variant, withRef, ...rest } = props

    const renderInput = (InputComponent: React.ComponentType<any>) => {
      return withRef ? (
        <InputComponent ref={ref} {...rest} />
      ) : (
        <InputComponent {...rest} />
      )
    }

    switch (variant) {
      case InputTypes.Date:
        return renderInput(DateInput)
      case InputTypes.Number:
        return renderInput(NumberInput)
      case InputTypes.Search:
        return renderInput(SearchInput)
      case InputTypes.Controller:
        return renderInput(InputComponent)
      default:
        return renderInput(InputBaseStyles)
    }
  }
)

export default CommonInput
